import { lazy } from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';

const SettingsIndex = lazy(() => import('@/features/settings/index/page'));
const SubcompaniesPage = lazy(() => import('@/features/settings/subcompanies/page'));
const DocumentTemplatesPage = lazy(
  () => import('@/features/settings/document-templates/page')
);
const LicenseTypesPage = lazy(
  () => import('@/features/settings/license-types/page')
);
const ToolsPage = lazy(() => import('@/features/settings/tools/page'));
const AuditLogPage = lazy(() => import('@/features/settings/audit/page'));
const FeatureFlagsPage = lazy(
  () => import('@/features/settings/feature-flags/page')
);
const TranslationsPage = lazy(
  () => import('@/features/settings/translations/page')
);
const UsersPage = lazy(() => import('@/features/settings/users/page'));

// Old `/settings/haken` renamed to `/settings/subcompanies` — brand
// coupling mistake. Vacation policy lives under `/leave/config`;
// the legacy `/settings/vacation` URL redirects there so old
// bookmarks survive.
export const settingsRoutes: RouteObject[] = [
  { path: 'settings', element: <SettingsIndex /> },
  { path: 'settings/subcompanies', element: <SubcompaniesPage /> },
  { path: 'settings/vacation', element: <Navigate to="/leave/config" replace /> },
  { path: 'settings/templates', element: <DocumentTemplatesPage /> },
  { path: 'settings/license-types', element: <LicenseTypesPage /> },
  { path: 'settings/tools', element: <ToolsPage /> },
  { path: 'settings/audit', element: <AuditLogPage /> },
  { path: 'settings/feature-flags', element: <FeatureFlagsPage /> },
  { path: 'settings/translations', element: <TranslationsPage /> },
  { path: 'settings/users', element: <UsersPage /> },
  // Settings.md spec URLs — alias to the canonical relay paths.
  { path: 'settings/haken', element: <Navigate to="/settings/subcompanies" replace /> },
  {
    path: 'settings/worker/templates',
    element: <Navigate to="/settings/templates" replace />,
  },
];
